import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { DefaultFontStack } from "../typography/typography";
import CallToActionButton from "../button/calltoaction/callToAction";
import EmailForm from "../form/email/email-form";
import Dialog from "../popup/vorne/components/dialog";

const CloseContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const FormContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 0px;
`;

const StyledCloseIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.mediumEmphasis};
  height: 17px;
  width: 17px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.emperor};
  flex-wrap: wrap;
  justify-content: center;

  padding-left: 15px;
  padding-right: 15px;
  padding-top: 2px;
  padding-bottom: 2px;
  box-sizing: border-box;

  ${(props) => props.theme.breakpoints.up(540)} {
    justify-content: space-between;
  }

  ${(props) => props.theme.breakpoints.up("desktop")} {
    text-align: left;
    flex-direction: row;

    align-items: center;
    height: 37px;
  }
  ${CallToActionButton} {
    margin: 0px;
  }
`;

const DescriptionText = styled.span`
  ${DefaultFontStack}
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.3px;
  color: #ffffff;
  margin-top: 5px;
  ${({ theme }) => theme.breakpoints.up("tablet")} {
    margin-top: 0px;
  }
  margin-right: 5px;
`;

const LearnMoreButton = styled(CallToActionButton)`
  display: flex;
  align-items: center;
  line-height: unset;
  margin-bottom: 5px;
  font-size: 14px;
  margin-top: 5px;
  :hover {
    background-color: "rgb(11, 78, 134)";
  }
`;

const BoldText = styled.span`
  font-weight: 600;
`;

const Popup = styled.div`
  position: absolute;
  margin-top: 5px;
  border-radius: 10px;
  box-sizing: border-box;
  z-index: 10;
  background-color: white;
  left: 0px;
  width: 100%;
  min-height: ${({ show }) => (show ? "350px" : "0px")};
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  max-height: ${({ show }) => (show ? "unset" : "0px")};
  visibility: ${({ show }) => (show ? "visible" : "hidden")};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  padding: 10px;

  ${({ theme }) => theme.breakpoints.up(400)} {
    left: unset;
    right: 10px;
    width: 350px;
    height: 350px;
  }
`;

const ButtonContainer = styled.div({
  display: "flex",
  gap: 5,
});

const IconButton = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  appearance: "none",
  border: "none",
  background: "unset",
});

const SubscriptionBar = ({
  className,
  buttonText,
  bannerText,
  boldText,
  disablePopover,
  buttonUrl,
}) => {
  const [show, setShow] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const toggleShow = () => {
    setShow((show) => !show);
  };

  const button = disablePopover ? (
    <ButtonContainer>
      <LearnMoreButton onClick={() => setShowDialog(true)}>
        SEE HOW VORNE XL WORKS
      </LearnMoreButton>
      <LearnMoreButton url={buttonUrl}>{buttonText}</LearnMoreButton>
    </ButtonContainer>
  ) : (
    <div>
      <LearnMoreButton onClick={toggleShow}>{buttonText}</LearnMoreButton>
      <Popup show={show}>
        <CloseContainer>
          <IconButton onClick={toggleShow}>
            <StyledCloseIcon icon={faClose} style={{ height: 20, width: 20 }} />
          </IconButton>
        </CloseContainer>
        <FormContainer>
          <EmailForm />
        </FormContainer>
      </Popup>
    </div>
  );

  return (
    <>
      <Container style={{ position: "relative" }} className={className}>
        <DescriptionText>
          {bannerText}
          <BoldText>{boldText}</BoldText>
        </DescriptionText>
        {button}
      </Container>
      {showDialog ? <Dialog onClose={() => setShowDialog(false)} /> : null}
    </>
  );
};

export default SubscriptionBar;
